import { useState } from 'react';
import api from '../Services/api';
import endpoints from '../Services/endpointAdmin';

const appendIfPresent = (formData, key, value) => {
  if (value !== undefined && value !== null && value !== '') {
    formData.append(key, value);
  }
};

const buildPenyaluranProgramPayload = (payload = {}) => {
  const formData = new FormData();

  appendIfPresent(formData, 'id_program', payload.id_program);
  appendIfPresent(formData, 'id_mahasiswa', payload.id_mahasiswa);
  appendIfPresent(formData, 'id_data_pengajuan', payload.id_data_pengajuan);
  appendIfPresent(formData, 'id_user', payload.id_user);
  appendIfPresent(formData, 'sumber_dana', payload.sumber_dana);
  appendIfPresent(formData, 'nominal_penyaluran', payload.nominal_penyaluran);
  appendIfPresent(formData, 'status_penyaluran', payload.status_penyaluran);
  appendIfPresent(formData, 'bukti_penyaluran', payload.bukti_penyaluran);

  return formData;
};

/**
 * @returns { Object } - Mengembalikan fungsi postPenyaluranProgram, serta status loading dan error.
 */
const usePostPenyaluranProgram = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Fungsi untuk mengirim data penyaluran program ke backend.
   * @param { Object } payload
   * @returns { Promise<Object> } - Mengembalikan data respons dari backend atau error.
   */
  const postPenyaluranProgram = async (payload) => {
    setLoading(true);
    setError(null);

    try {
      // Memastikan endpoint create terdefinisi
      if (!endpoints.penyaluran_program?.create) {
        throw new Error('endpoints.penyaluran_program.create is not defined');
      }

      const data = buildPenyaluranProgramPayload(payload);

      // Mengirim POST request ke endpoint yang sesuai
      const response = await api.post(endpoints.penyaluran_program.create, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      // Mengembalikan data respons jika berhasil
      return response.data;
    } catch (err) {
      console.error('Error creating penyaluran program:', err);
      // Mengambil pesan error dari respons jika tersedia
      setError(err.response?.data?.error || err.message || 'Terjadi kesalahan saat menambah data penyaluran program.');
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { postPenyaluranProgram, loading, error };
};

export default usePostPenyaluranProgram;
